import React, { useEffect, useState, useContext } from "react";
import { Container, Form, Button, Table } from "react-bootstrap";
import AuthContext from "../../context/AuthContext";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { inRange } from "lodash";
import { useForm } from "react-hook-form";
import { toast } from "wc-toast";
const Settlement = () => {
  let { user, user_coins } = useContext(AuthContext);
  let user_by_created = user?.id;
  const [loader, setLoader] = useState(false);
  const [results, setResults] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    keyword: "",
    status: "active",
    created_by: user_by_created,
  });


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({});
  function getPositiveNewRefrence(data) {
    return data.filter((item) => item.value > 0);
  }

  function splitByNewRefrence(data) {
    const filtered = data.filter((item) => item.newRefrence !== 0);
    const positive = filtered.filter((item) => item.newRefrence > 0);
    const negative = filtered
      .filter((item) => item.newRefrence < 0)
      ?.map((res) => {
        return {
          ...res,
          shortBalance:
            user_coins - Math.abs(res?.newRefrence) > 0
              ? 0
              : Math.abs(user_coins - Math.abs(res?.newRefrence)),
        };
      });

    return { positive, negative };
  }

  const getData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.settlementList,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        let updated = response_users?.results?.data?.map((user) => {
          const balance =
            user?.userType == "user"
              ? Math.sign(user?.totalCoins1) === -1
                ? user?.totalCoins1
                : user?.totalCoins1
              : Math.sign(user?.totalCoins) === -1
              ? user?.totalCoins
              : user?.totalCoins;
          return {
            ...user,
            newRefrence:
              user.creditReference > 0
                ? (user.creditReference - balance).toFixed(2)
                : balance.toFixed(2),
          };
        });
        setResults(splitByNewRefrence(updated));
      }
    }
  };

  useEffect(() => {
    getData();
  }, [user_coins]);

  const onSubmit = async (body) => {
    let positive = getPositiveNewRefrence(results?.positive)?.map((d) => {
      return {
        user_id: d._id,
        dw_type: "D",
        amount: parseFloat(d.value),
        remarks: d?.remark || "",
      };
    });
    let negative = getPositiveNewRefrence(results?.negative)?.map((d) => {
      return {
        user_id: d._id,
        dw_type: "W",
        amount: parseFloat(d.value),
        remarks: d?.remark || "",
      };
    });
    let array = [...negative, ...positive];
    if (array?.length > 0) {
      setLoader(true);
      const { status, data: response_users } = await apiPost(
        apiPath.transactionSettle,
        {
          password: body.password,
          transactionInsert: array,
        }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users.message);
          getData();
        } else {
          toast.error(response_users.message);
        }
      }
      setLoader(false);
    } else {
      toast.error("Please enter correct input");
    }
  };

  return (
    <section className="main-inner-outer py-4">
      <Container fluid>
        <div className="find-member-sec search_banking_detail">
          <div className="db-sec">
            <h2 className="common-heading page-title">Settlement List</h2>
          </div>

          <div className="inner-wrapper">
            <div
              style={{
                display: "flex",
                // alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
              className="common-container"
            >
              <div className="responsive" style={{ width: "48%" }}>
                <div
                  style={{
                    padding: "10px",
                    background: "green",
                    color: "white",
                    width: "100%",
                    fontWeight: "600",
                  }}
                >
                  Creditors Account (dena hai)
                </div>
                <Table className="banking_detail_table table-color">
                  <thead>
                    <tr>
                      <th scope="col" style={{ background: "lightgrey" }}>
                        Account{" "}
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Client (P/L)
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Short Balance
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Settle Amount
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Remark
                      </th>
                    </tr>
                  </thead>{" "}
                  <tbody>
                    {results?.negative?.length > 0
                      ? results?.negative?.map((res, id) => {
                          return (
                            <tr key={id}>
                              <td>{res?.username}</td>
                              <td
                                style={{ color: "green", textAlign: "right" }}
                              >
                                {Math.abs(res?.newRefrence)}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  color:
                                    res?.shortBalance > 0 ? "red" : "black",
                                }}
                              >
                                {res?.shortBalance}
                              </td>{" "}
                              <td style={{ textAlign: "right" }}>
                                <div>
                                  <input
                                    type="number"
                                    placeholder="Amount"
                                    value={res?.value || ""}
                                    // disabled={res?.shortBalance > 0}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setResults((prev) => {
                                        return {
                                          ...prev,
                                          negative: prev?.negative?.map(
                                            (item) => {
                                              if (item._id === res._id) {
                                                return {
                                                  ...item,
                                                  value: inRange(
                                                    newValue,
                                                    0,
                                                    Math.abs(res?.newRefrence) +
                                                      1
                                                  )
                                                    ? newValue
                                                    : item?.value,
                                                };
                                              }
                                              return item;
                                            }
                                          ),
                                        };
                                      });
                                    }}
                                  />
                                  <button
                                    onClick={() => {
                                      if (res?.shortBalance > 0) {
                                        toast.error(
                                          `You must have ${res?.shortBalance} balance before settle`
                                        );
                                      } else {
                                        setResults((prev) => {
                                          return {
                                            ...prev,
                                            negative: prev?.negative?.map(
                                              (item) => {
                                                if (item._id === res._id) {
                                                  return {
                                                    ...item,
                                                    value: Math.abs(
                                                      res?.newRefrence
                                                    ),
                                                  };
                                                } else {
                                                  return item;
                                                }
                                              }
                                            ),
                                          };
                                        });
                                      }
                                    }}
                                    style={{
                                      color: "white",
                                      background: "green",
                                      border: "none",
                                      padding: "3px 5px",
                                      borderRadius: "2px",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    Full Settle
                                  </button>
                                </div>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <div>
                                  <input
                                    type="text"
                                    placeholder="Remarks"
                                    value={res?.remark || ""}
                                    onChange={(e) => {
                                      setResults((prev) => {
                                        return {
                                          ...prev,
                                          negative: prev?.negative?.map(
                                            (item) => {
                                              if (item._id === res._id) {
                                                return {
                                                  ...item,
                                                  remark: e.target.value,
                                                };
                                              } else {
                                                return item;
                                              }
                                            }
                                          ),
                                        };
                                      });
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </Table>
              </div>{" "}
              <div className="responsive" style={{ width: "48%" }}>
                {" "}
                <div
                  style={{
                    padding: "10px",
                    background: "red",
                    color: "white",
                    width: "100%",
                    fontWeight: "600",
                  }}
                >
                  Debtors Account (lena hai)
                </div>
                <Table className="banking_detail_table table-color">
                  <thead>
                    <tr>
                      <th scope="col" style={{ background: "lightgrey" }}>
                        Account{" "}
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Client (P/L)
                      </th>{" "}
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Settle Amount
                      </th>
                      <th
                        style={{ textAlign: "right", background: "lightgrey" }}
                        scope="col"
                      >
                        Remark
                      </th>
                    </tr>
                  </thead>{" "}
                  <tbody>
                    {results?.positive?.length > 0
                      ? results?.positive?.map((res) => {
                          return (
                            <tr>
                              <td>{res?.username}</td>
                              <td style={{ color: "red", textAlign: "right" }}>
                                {res?.newRefrence}
                              </td>

                              <td style={{ textAlign: "right" }}>
                                <div>
                                  <input
                                    type="number"
                                    placeholder="Amount"
                                    value={res?.value || ""}
                                    onChange={(e) => {
                                      setResults((prev) => {
                                        return {
                                          ...prev,
                                          positive: prev?.positive?.map(
                                            (item) => {
                                              if (item._id === res._id) {
                                                return {
                                                  ...item,
                                                  value: inRange(
                                                    e.target.value,
                                                    0,
                                                    Math.abs(res?.newRefrence) +
                                                      1
                                                  )
                                                    ? e.target.value
                                                    : item?.value,
                                                };
                                              } else {
                                                return item;
                                              }
                                            }
                                          ),
                                        };
                                      });
                                    }}
                                  />{" "}
                                  <button
                                    onClick={() =>
                                      setResults((prev) => {
                                        return {
                                          ...prev,
                                          positive: prev?.positive?.map(
                                            (item) => {
                                              if (item._id === res._id) {
                                                return {
                                                  ...item,
                                                  value: Math.abs(
                                                    res?.newRefrence
                                                  ),
                                                };
                                              } else {
                                                return item;
                                              }
                                            }
                                          ),
                                        };
                                      })
                                    }
                                    style={{
                                      color: "white",
                                      background: "red",
                                      border: "none",
                                      padding: "3px 5px",
                                      borderRadius: "2px",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    Full Settle
                                  </button>
                                </div>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <div>
                                  <input
                                    type="text"
                                    placeholder="Remarks"
                                    value={res?.remark || ""}
                                    onChange={(e) => {
                                      setResults((prev) => {
                                        return {
                                          ...prev,
                                          positive: prev?.positive?.map(
                                            (item) => {
                                              if (item._id === res._id) {
                                                return {
                                                  ...item,
                                                  remark: e.target.value,
                                                };
                                              } else {
                                                return item;
                                              }
                                            }
                                          ),
                                        };
                                      });
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          <div
            style={{ paddingTop: "0" }}
            className="paymoney d-flex justify-content-center align-items-center"
          >
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="paymoney_form justify-content-center"
            >
              <Form.Control
                type="password"
                placeholder="Password"
                {...register("password", {
                  required: "Please enter password",
                })}
              />
              <button
                disabled={loader}
                style={{ color: "black", marginRight: "5px", color: "black" }}
                type="submit"
                className="btn green-btn"
              >
                {loader ? "Submitting..." : "Submit Payment"}
              </button>{" "}
              <button className="clear_btn btn" type={"button"}>
                Clear All
              </button>
            </Form>
          </div>
          <div></div>
        </div>
      </Container>
    </section>
  );
};

export default Settlement;
